const DETAILS_FORM_PASSWORD_SET = 'DETAILS_FORM_PASSWORD_SET';
const DETAILS_FORM_PASSWORD_SET_VALIDATION_MESSAGE = 'DETAILS_FORM_PASSWORD_SET_VALIDATION_MESSAGE';
const DETAILS_FORM_PASSWORD_SET_VISUALIZATION = 'DETAILS_FORM_PASSWORD_SET_VISUALIZATION';
const DETAILS_FORM_PASSWORD_SET_API_ERROR = 'DETAILS_FORM_PASSWORD_SET_API_ERROR';
const DETAILS_FORM_PASSWORD_SET_FOCUS = 'DETAILS_FORM_PASSWORD_SET_FOCUS';
const DETAILS_FORM_PASSWORD_BLURRED = 'DETAILS_FORM_PASSWORD_BLURRED';
const DETAILS_FORM_PASSWORD_FOCUSED = 'DETAILS_FORM_PASSWORD_FOCUSED';
const DETAILS_FORM_PASSWORD_CHANGE = 'DETAILS_FORM_PASSWORD_CHANGE';

const accountFormPasswordSet = (password) => ({
  type: DETAILS_FORM_PASSWORD_SET,
  payload: password
});

const accountFormPasswordSetValidationMessage = (validationMessage) => ({
  type: DETAILS_FORM_PASSWORD_SET_VALIDATION_MESSAGE,
  payload: validationMessage
});

const accountFormPasswordSetVisualization = (visualized) => ({
  type: DETAILS_FORM_PASSWORD_SET_VISUALIZATION,
  payload: visualized
});

const accountFormPasswordSetFocus = (focused) => ({
  type: DETAILS_FORM_PASSWORD_SET_FOCUS,
  payload: focused
});

const accountFormPasswordBlur = (markedAsWrong, validationMessage) => ({
  type: DETAILS_FORM_PASSWORD_BLURRED,
  payload: {
    markedAsWrong,
    validationMessage
  }
});

const accountFormPasswordChange = (payload) => ({
  type: DETAILS_FORM_PASSWORD_CHANGE,
  payload
});

const accountFormPasswordFocus = () => ({
  type: DETAILS_FORM_PASSWORD_FOCUSED
});

export {
  accountFormPasswordSetValidationMessage,
  accountFormPasswordSetVisualization,
  accountFormPasswordFocus,
  accountFormPasswordSetFocus,
  accountFormPasswordBlur,
  accountFormPasswordSet,
  accountFormPasswordChange,
  DETAILS_FORM_PASSWORD_CHANGE,
  DETAILS_FORM_PASSWORD_FOCUSED,
  DETAILS_FORM_PASSWORD_BLURRED,
  DETAILS_FORM_PASSWORD_SET_FOCUS,
  DETAILS_FORM_PASSWORD_SET_API_ERROR,
  DETAILS_FORM_PASSWORD_SET_VALIDATION_MESSAGE,
  DETAILS_FORM_PASSWORD_SET,
  DETAILS_FORM_PASSWORD_SET_VISUALIZATION
};

